
// src/helpers/url-regexp.js

export function urlRegex(opts) {
  opts = opts || {};

  var protocol = '(?:(?:(http|https|ftp|mailto)+:)?//)';
  var auth = '(?:[^/\\s"\'()<>{}\\[\\]]+(?::[^/\\s"\'()<>{}\\[\\]]*)?@)?';
  var host = '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)';
  var domain = '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*';
  var tld = '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?';
  var port = '(?::\\d{2,5})?';
  var path = '(?:[/?#][^\\s"\'()<>{}\\[\\]]*)?';
  var phonenumber = '0[-0-9]{9,16}';
  var email = '(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})';
  var regex = [
    '(?:' + protocol + '|www\\.)' + auth, '(?:localhost|' + host + domain + tld + ')',
    port, path
  ].join('');
  if (opts.phoneNumber)
    regex = '(' + regex + '|' + phonenumber + ')'
  if (opts.email)
    regex = '(' + regex + '|' + email + ')'

  return opts.exact ? new RegExp('(?:^' + regex + '$)', 'i') : new RegExp(regex, 'ig');
};

export function textUrl(value) {
  let match
  let matchObj = {}
  let count = 0
  const regex = urlRegex(value)

  while ((match = value.match(regex)) != null) {
      count += 1
      matchObj[`[${count}]`] = match[0]
      value = value.replace(match[0], `[${count}]`)
  }
  const keys = Object.keys(matchObj)
  keys.forEach((key) => {
    value = value.replace(key, `,${matchObj[key]},`)
  })

  const fieldsValueText_split =  value.split(',')
  return fieldsValueText_split
}



// WEBPACK FOOTER //
// ./src/helpers/url-regexp.js